import { MenuItem, MenuList } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { memo, useCallback, useRef, useState } from 'react';

import { ReactComponent as SortIcon } from '../Icons/sort.svg';
import { UIActions } from "../Store/ViewMenuSlice";
import { useDispatch } from "react-redux";
import MainFilterDropdownMenuWithButton from './Menu/MainFilterDropdownMenuWithButton';
import EscapeListener from './Utils/EscapeListener';
import TabAwayListener from './Utils/TabAwayListener';

const useStyles = makeStyles((theme) => ({
    sortMenuUl: {
        paddingTop: 0,
        paddingBottom: 0,
        '& .MuiListItem-root': {
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(1.5),
            color: theme.palette.secondary.light,
            letterSpacing: theme.typography.subtitle1.letterSpacing
        },
        '& .MuiListItem-button:hover': {
            color: theme.palette.secondary.contrastText,
            backgroundColor: 'rgba(255, 255, 255, 0.05)'
        },
        '& .Mui-selected': {
            backgroundColor: 'rgba(255, 255, 255, 0.02)'
        }
    },
}));

export default memo(function SortMenu({ showRuntimeOptions = false, showDataAdded = false }) {
    const classes = useStyles();

    const [open, setOpen] = useState(false);

    const menuRef = useRef(null);

    const sortMenuList = [
        {
            type: 'a-z',
            uid: 1,
            label: 'A - Z',
        },
        {
            type: 'z-a',
            uid: 2,
            label: 'Z - A',
        },
        showDataAdded 
            ? {
                type: 'date-added',
                uid: 3,
                label: 'Date Added',
            }
            : null,
        showRuntimeOptions
            ? {
                type: 'runtime-ascending',
                uid: 4,
                label: 'Runtime - Ascending',
            }
            : null,
        showRuntimeOptions
            ? {
                type: 'runtime-descending',
                uid: 5,
                label: 'Runtime - Descending',
            }
            : null,
    ]
    .filter(x => x);

    console.log("sortMenuList", sortMenuList)

    const dispatch = useDispatch();

    const handleClose = () => {
        console.log("handleClose");
        setOpen(false);
    };

    const handlSortType = useCallback((type) => {
        dispatch(UIActions.setSortType({ sortType: type }));
        handleClose();
    }, [dispatch]);

    const anchorRef = useRef(null);

    return (
        <MainFilterDropdownMenuWithButton
            open={open}
            handleToggle={() => setOpen(open => !open)}
            buttonIcon={SortIcon}
            buttonLabel="Sort"
            anchorRef={anchorRef}
        >
            <EscapeListener enabled={open} onKeyPress={() => {
                setOpen(false);
                if (anchorRef.current)
                    anchorRef.current.focus();
            }}>
                <TabAwayListener tabRef={menuRef} enabled={open} tabAwayHandler={() => setOpen(false)}>
                    <MenuList id="menu-list-grow" className={classes.sortMenuUl} ref={menuRef}>
                        {sortMenuList.map((item) => (
                            <MenuItem key={item.uid} onClick={() => handlSortType(item.type)} tabIndex={0}>{item.label}</MenuItem>
                        ))}
                    </MenuList>
                </TabAwayListener>
            </EscapeListener>
        </MainFilterDropdownMenuWithButton>
    );
});